import preval from 'preval.macro';

const config = {
  // eslint-disable-next-line no-undef
  appVersion: preval`
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const totalMinutes = date.getHours() * 60 + date.getMinutes();
  module.exports = \`\${year}.\${month}.\${day}.\${totalMinutes}\`;
`,
  development: false,
  origin: "https://superfastgpt.com",
  gatewayBaseUrl: "https://wormhole.graysense.one",
  wsGatewayBaseUrl: "wss://wormhole.graysense.one",
  appInsightsIntrumentationKey: 'InstrumentationKey=46530d3e-1315-46e2-903e-d3f135087cd8;IngestionEndpoint=https://eastus-8.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/',
};

export default config;
